import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Intro from '@/components/Intro'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/intro',
      name: 'Intro',
      component: Intro
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js